import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import InsightsList from "./InsightsList";

import { observer } from "mobx-react";

class Insights extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    UNSAFE_componentWillMount() {
        this.props.store.setCurrentSection("insights");

        // Breadcrumbs
        this.props.store.setBreadcrumbs([{ title: "Insights" }]);
    }

    render() {
        return (
            <Switch>
                {/* <Route
                    path="/dashboard/insights/:id/report"
                    //   render={props => (
                    //       // <CompetitorsReport
                    //       //     store={this.props.store}
                    //       //     {...props}
                    //       // />
                    //   )}
                /> */}
                <Route
                    render={props => (
                        <InsightsList store={this.props.store} {...props} />
                    )}
                />
            </Switch>
        );
    }
}

export default observer(Insights);
